import React from 'react';
import styled from 'styled-components';

import {Device} from '../../../constants';
import {FeatureVideo} from '../FeatureHeroCarousel/Types';

import {CrewBackgroundContainer, CrewPattern} from './components';

const StyledCrewSolidBackground = styled.div<{bgColor?: string; background?: FeatureVideo}>`
  height: 100%;
  width: 100%;
  background-size: cover;

  ${({bgColor, background}) =>
    background && background.content
      ? `
          background: url("${background.content[0]}") top right no-repeat;
          background-size: cover;
        `
      : ` background-color: ${bgColor ?? '#fff'};`}

      @media screen and ${Device.mobileL} {
        ${({background}) =>
          background && background.mobileImage
            ? `
              background: url("${background.mobileImage}") right top no-repeat;
              background-size: cover;
            `
            : null}
`;

interface Props {
  background: FeatureVideo;
  mobile: boolean;
  tablet: boolean;
  crewPattern: string;
}
const CrewBackground = ({background, crewPattern, mobile, tablet}: Props) => {
  return (
    <CrewBackgroundContainer>
      <StyledCrewSolidBackground bgColor={'rgb(68, 15, 104)'} background={background} />
      <CrewPattern pattern={crewPattern} />
    </CrewBackgroundContainer>
  );
};

export default CrewBackground;
